
const queries = {
  xs: '@media (min-width: 320px) and (max-width: 439px)',
  s: '@media (min-width: 440px) and (max-width: 767px)',
  m: '@media (min-width: 768px) and (max-width: 1023px)',
  l: '@media (min-width: 1024px) and (max-width: 1439px)',
  xl: '@media (min-width: 1440px)',
};

export default queries;
